// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"aA-z","giftOrPromoSelector":"bA-z","disabled":"cA-z","subTitle":"dA-z","selectShipAddressMessage":"eA-z","changePayment":"fA-z"};